import { Injectable } from '@angular/core';
import { DpButtonStateIcon, DpFieldButton, DpFieldText, DpFormRow, DpModalForm, DpModalFormService, DpModalFormSize } from '@docpath/webcomponents';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { IndexService } from '../models/index-service';
import { IndexServicesService } from './index-services.service';
import { IndexServicesHttpService } from './index-services-http.service';


@Injectable({
    providedIn: 'root'
})
export class IndexServicesFormService {

    readonly i18nPrefix = 'services-config.index-services.form';

    selectedIndexService?: IndexService;

    constructor(
        private readonly modalFormService: DpModalFormService,
        private readonly indexServicesHttpService: IndexServicesHttpService,
        private readonly indexServicesService: IndexServicesService
    ) {
    }

    initIndexServiceForm(testClick: (fieldButton: DpFieldButton) => void): DpModalForm {
        return new DpModalForm({
            header: `${this.i18nPrefix}.header.new-index-service`,
            rows: [
                new DpFormRow([
                    new DpFieldText({ name: 'name', required: true, column: 10 })
                ]),
                new DpFormRow([
                    new DpFieldText({ name: 'url', required: true, column: 7 }),
                    new DpFieldButton({ name: 'test', click: testClick, stateIcons: true, labelHidden: true, column: 2 })
                ]),
                new DpFormRow([
                    new DpFieldText({ name: 'description', column: 10 })
                ])
            ],
            size: DpModalFormSize.Lg,
            i18nPrefix: this.i18nPrefix
        });
    }

    openCreationIndexServiceForm(): void {
        const form = this.initModalForm();
        form.header = `${this.i18nPrefix}.header.new-index-service`;

        form.submit = (value, activeModal) => {
            this.postIndexService(value as IndexService, activeModal);
        };

        const modalReference = this.modalFormService.open(form);
        modalReference.closed.subscribe(() => this.hideTestIcon(form));
    }

    openEditIndexServiceForm(indexService: IndexService): void {
        const form = this.initModalForm();
        this.selectedIndexService = indexService;
        form.fields.forEach(field => {
            if (field.name === 'ip') {
                field.disabled = true;
            }
        });
        form.header = `${this.i18nPrefix}.header.edit-index-service`;

        const modalReference = this.modalFormService.open(form);

        form.submit = (value, activeModal) => {
            const newRole = { id: indexService.id, ...value };
            this.putIndexService(newRole, activeModal);
        };

        modalReference.shown.subscribe(() => {
            form.setValue(indexService);
        });

        modalReference.closed.subscribe(() => {
            this.hideTestIcon(form);
            this.selectedIndexService = undefined;
        });
    }

    private initModalForm(): DpModalForm {
        const form = this.initIndexServiceForm(fieldButton => {
            const indexService = form.getValue() as IndexService;
            this.testConnection(fieldButton, indexService);
        });

        return form;
    }

    private testConnection(testButton: DpFieldButton, indexService: IndexService) {
        const { url } = indexService;
        const queryParameters = { url };

        testButton.state = DpButtonStateIcon.Loading;

        this.indexServicesHttpService.testConnection(testButton, queryParameters);
    }

    private postIndexService(indexService: IndexService, activeModal: NgbModalRef): void {
        this.indexServicesHttpService.createIndexService(indexService, () => {
            activeModal.close();
            this.indexServicesService.notifyIndexServicesChange();
        });
    }

    private putIndexService(indexService: IndexService, activeModal: NgbModalRef): void {
        this.indexServicesHttpService.editIndexService(indexService, () => {
            activeModal.close();
            this.indexServicesService.notifyIndexServicesChange();
        });
    }

    private hideTestIcon(form: DpModalForm) {
        const createSchemaField = form.fields.find(field => field.name === 'test') as DpFieldButton;

        if (createSchemaField) {
            createSchemaField.state = DpButtonStateIcon.Hidden;
        }
    }

}